<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-10-11 17:14:51
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-11 18:28:27
 * @FilePath: \seller.sviptrader.com\src\components\business\applySampleDrawer\components\topAnchors\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row-center-between anchors">
		<div class="left">
			<div class="step flex-row-align-center">
				<div class="item flex-row-align-center">
					<div class="num yx-color-white DIN">1</div>
					<div class="yx-color-text-primary font-h5-regular ml-8"> 选择合作对象 </div>
				</div>
				<div class="circle-box ml-24 mr-24 flex-row-align-center">
					<i class="circle mr-2" v-for="item in 6" :key="item"></i>
				</div>
				<div class="item flex-row-align-center">
					<div class="num yx-color-white DIN">2</div>
					<div class="yx-color-text-primary font-h5-regular ml-8"> 确认合作商品 </div>
				</div>
				<div class="circle-box ml-24 mr-24 flex-row-align-center">
					<i class="circle mr-2" v-for="item in 6" :key="item"></i>
				</div>
				<div class="item flex-row-align-center">
					<div class="num yx-color-white DIN">3</div>
					<div class="yx-color-text-primary font-h5-regular ml-8"> 确认合作约定 </div>
				</div>
			</div>
		</div>
		<a class="right cursor-pointer" href="https://yangxuan.feishu.cn/docx/HZIUdd2krow0lvxgsqpccj4knTh?from=from_copylink" target="_blank">
			<div class="tag flex-row-align-center">
				<i class="i-light-bulb"></i>
				<span class="ml-8 yx-color-text-primary">如何发起申样?</span>
			</div>
		</a>
	</div>
</template>
<script>
export default {
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped>
.anchors {
	.left {
		.step {
			.item {
				.num {
					background-color: @color-primary;
					border-radius: 2px;
					width: 24px;
					height: 24px;
					text-align: center;
					line-height: 24px;
				}
			}
			.circle {
				width: 4px;
				height: 4px;
				border-radius: 4px;
				background-color: #c9cdd4;
			}
		}
	}
	.right {
		.tag {
			background: #fff6f2;
			height: 30px;
			border-radius: 30px;
			font-size: 13px;
			line-height: 30px;
			padding: 0px 12px;
		}
	}
}
</style>
